import React from 'react';

const HomeEditBanner = ({ themeData }: any) => {
  return (
    <div
      className="home_single_search theme5"
      style={{
        background: `var(--primary-color) url(${themeData?.theme_5?.home?.section_1?.banner}) no-repeat top center`,
      }}
    >
      <div className="container b">
        <div className="row">
          {/* Left Column */}
          <div className="col-md-12 col-lg-7">
            <div className="banner-search-wrap">
              <span className="banner-tag"></span>
              <h1
                style={{
                  color:
                    themeData?.theme_5?.home?.section_1?.title_color
                      ? `#${themeData.theme_5.home.section_1.title_color}`
                      : '#ffffff',
                }}
              >
                {themeData?.theme_5?.home?.section_1?.title}
              </h1>
              <p
                className="d-none d-md-block"
                style={{
                  color:
                    themeData?.theme_5?.home?.section_1?.paragraph_color
                      ? `#${themeData.theme_5.home.section_1.paragraph_color}`
                      : '#ffffff',
                }}
              >
                {themeData?.theme_5?.home?.section_1?.paragraph}
              </p>
            </div>
          </div>

          {/* Right Column - Image */}
          <div className="col-lg-5 d-none d-lg-block">
            <div className="heroimg">
              {themeData?.theme_5?.home?.section_1?.banner_two &&
              themeData?.theme_5?.home?.section_1?.banner_type == 'image' ? (
                <img
                  src={themeData?.theme_5?.home?.section_1?.banner_two}
                  alt="Hero Image"
                  className="img-fluid"
                />
              ) : (
                themeData?.theme_5?.home?.section_1?.banner_two && (
                  <>
                    <video
                      loop
                      autoPlay
                      className="img-fluid"
                      src={themeData?.theme_5?.home?.section_1?.banner_two}
                    ></video>
                  </>
                )
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeEditBanner;
